// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* nav{
    width: 300px;
    height: 100vh;
    border-right: 1px solid #c6c6c6;
} */

.mobile-menu-toggle {
  display: none;
  position: fixed;
  top: 14px;
  left: 16px;
  z-index: 1001;
  width: 40px;
  height: 40px;
  align-items: center;
  justify-content: center;
  border: 1px solid #e6e9f0;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  color: var(--purple);
}

@media screen and (max-width: 768px) {
  .mobile-menu-toggle {
    display: flex;
  }
}`, "",{"version":3,"sources":["webpack://./src/Module/sidebar.css"],"names":[],"mappings":"AAAA;;;;GAIG;;AAEH;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,UAAU;EACV,aAAa;EACb,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["/* nav{\r\n    width: 300px;\r\n    height: 100vh;\r\n    border-right: 1px solid #c6c6c6;\r\n} */\r\n\r\n.mobile-menu-toggle {\r\n  display: none;\r\n  position: fixed;\r\n  top: 14px;\r\n  left: 16px;\r\n  z-index: 1001;\r\n  width: 40px;\r\n  height: 40px;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 1px solid #e6e9f0;\r\n  border-radius: 50%;\r\n  background: #fff;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\r\n  cursor: pointer;\r\n  color: var(--purple);\r\n}\r\n\r\n@media screen and (max-width: 768px) {\r\n  .mobile-menu-toggle {\r\n    display: flex;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
